export default __webpack_public_path__ + "img/leasity-brand.8efad4f5.svg";